import { Injectable } from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class UrlInfoService {

  constructor(private router: Router) {

  }

  public loadRouting() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          localStorage.setItem('previousUrl', localStorage.getItem('currentUrl'));
          localStorage.setItem('currentUrl', this.router.url);
        }
      });
  }
}
